import { render, staticRenderFns } from "./ButtonBlock.vue?vue&type=template&id=6d2a2e20&"
import script from "./ButtonBlock.vue?vue&type=script&lang=js&"
export * from "./ButtonBlock.vue?vue&type=script&lang=js&"
import style0 from "./button-block.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports